import React, { useState, useEffect } from 'react'
import api from './api'
import '../css/Login.css'

import Logo from '../images/logo.png'

import { useNavigate, useSearchParams, Link } from 'react-router-dom'

import {
    LockOutlined,
    UserOutlined,
    // QqOutlined
} from '@ant-design/icons'
import { Button, Form, Input, message, Checkbox, Divider, ConfigProvider } from 'antd'
import md5 from 'js-md5'

//  本地存储已同意, 下次无需继续此操作
// let useragreement_ = localStorage.getItem('login_useragreement') ? localStorage.getItem('login_useragreement') : false


let captcha_g = null


//  登陆布局
function Login(props) {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [search] = useSearchParams()
    const [data, setData] = useState({ botToken: null })

    //  如果本地存储已同意, 下次无需继续此操作
    const [useragreement, setUseragreement] = useState(localStorage.getItem('login_useragreement') ? localStorage.getItem('login_useragreement') : false)

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)
        const state = searchParams.get('state')

        setTimeout(() => {
            if (props.state.token) {
                navigate(state || "/", { replace: true })
            }
        }, 200)



        // const searchParams = new URLSearchParams(window.location.search)
        const code = searchParams.get('code')

        if (code) {
            console.log(code);

            const key = Date
            message.loading({ key, content: '正在登陆中...', })
            setLoading(true)
            setTimeout(() => {
                api.post('/api/v2/user/login', {
                    code: code,
                })
                    .then((res) => {
                        if (res.data.code === 200) {
                            localStorage.setItem('n2yun_user', JSON.stringify(res.data.data.data))
                            props.handleChange({
                                token: res.data.data.data.token,
                                user: res.data.data.data,
                                login: true
                            })
                            message.success({ key, content: '登陆成功,欢迎回来' })
                            props.setCookie('n2yunToken', res.data.data.data.token)
                            localStorage.setItem('login_useragreement', true)
                            loginAction()
                        } else {
                            message.error({ key, content: res.data.data.text })
                            setLoading(false)

                            if (captcha_g) {
                                setData({ ...data, botToken: null })
                                captcha_g.reset(); // 调用该接口进行重置
                            }
                        }
                    })
                    .catch((error) => {
                        message.error('网络异常,无法连接服务器 error: ' + error)
                        setLoading(false)
                    })
            }, 10);
        }





        //  人机验证
        window.initGeetest4({
            captchaId: 'e2f7db7a36cae0fcec9320216a172878',
            nativeButton: {
                width: '300px',
            },
        }, function (captcha) {
            // captcha为验证码实例
            captcha.appendTo("#DX_demo");// 调用appendTo将验证码插入到页的某一个元素中，这个元素用户可以自定义

            captcha_g = captcha

            captcha.onReady(function () {
                //your code
            }).onSuccess(function () {
                var token = captcha.getValidate()
                setData({ ...data, botToken: token })

                //your code
            }).onError(function () {
                //your code


            })
        });
    }, [])

    //  设置共享 Cookie

    //  跳转
    function loginAction() {
        var redirect = search.get("redirect") || "/"

        let login_sso_url = localStorage.getItem('login_sso_url') ? localStorage.getItem('login_sso_url') : false
        if (login_sso_url) {
            navigate('/sso/' + login_sso_url, { replace: true })
            return
        }
        navigate(redirect, { replace: true })
    }

    //  提交登陆
    function onFinish(values) {
        if (!data.botToken) {
            message.warning('请完成人机验证')
            return
        }

        const key = Date
        message.loading({ key, content: '正在登陆中...', })
        setLoading(true)
        setTimeout(() => {
            api.post('/api/v2/user/login', {
                name: values.username,
                password: md5(values.password),
                // access_token: accessToken,
                botToken: data.botToken,
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        localStorage.setItem('n2yun_user', JSON.stringify(res.data.data.data))
                        props.handleChange({
                            token: res.data.data.data.token,
                            user: res.data.data.data,
                            login: true
                        })
                        message.success({ key, content: '登陆成功,欢迎回来' })
                        props.setCookie('n2yunToken', res.data.data.data.token)
                        localStorage.setItem('login_useragreement', true)
                        loginAction()
                    } else {
                        message.error({ key, content: res.data.data.text })
                        setLoading(false)

                        if (captcha_g) {
                            setData({ ...data, botToken: null })
                            captcha_g.reset(); // 调用该接口进行重置
                        }
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器 error: ' + error)
                    setLoading(false)
                })
        }, 10);
    }


    function WXLogin() {
        if (!data.botToken) {
            message.warning('请完成人机验证')
            return
        }

        const key = Date
        message.loading({ key, content: '正在请求中...', })
        setLoading(true)
        api.post('/api/v2/open_access/sso', {
            name: 'getTpp_Login',
        })
            .then((res) => {
                if (res.data.code === 200) {
                    const link = document.createElement('a')

                    link.href = res.data.data.data.url

                    message.success({ key, content: '已获取到微信快捷登录地址, 正在跳转至目标网址中...' })

                    // link.target = '_blank';  // 关键修改点
                    link.rel = 'noopener noreferrer'; // 安全建议

                    setTimeout(() => {
                        link.click()
                    }, 1500);

                } else {
                    // message.error(res.data.data.text)
                    message.error({ key, content: res.data.data.text })

                    setLoading(false)
                }
            })
            .catch((error) => {
                // message.error('网络异常,无法连接服务器')
                message.success({ key, content: '网络异常,无法连接服务器 error: ' + error })

                setLoading(false)
            })
    }

    // //  QQ快捷登录
    // function QQ() {
    //     let url = search.get("redirect") || "/"
    //     const link = document.createElement('a')
    //     link.href = 'https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=102039079&redirect_uri=https://app.n2yun.com.cn/api/v2/qq_connect&state=' + url
    //     link.click()
    // }

    return (
        <div className='login'>
            <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
            >
                <div className='logo animate__animated animate__lightSpeedInLeft'>
                    <Link to="/">
                        <img src={Logo} alt='logo'></img>
                    </Link>
                </div>

                <Form.Item
                    name="username"
                    rules={[
                        {
                            required: true,
                            message: '请输入用户名/邮箱地址!',
                        },
                    ]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="用户名/邮箱地址" />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: '请输入密码!',
                        },
                    ]}
                >
                    <Input
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="密码"
                    />
                </Form.Item>

                {/* <Form.Item>
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                        <a onClick={() => {
                            message.error('已关停此功能')
                        }} ><UserOutlined /> 子用户</a>
                    </Form.Item>
                    <a className="login-form-forgot" href="/forget_password">忘记密码?</a>
                </Form.Item> */}

                <Form.Item>
                    <div id="DX_demo" style={{ marginBottom: 20 }}></div>

                    <Checkbox style={{ marginBottom: 20 }} checked={data.useragreement} onChange={(e) => {
                        setUseragreement(e.target.checked)
                    }}>我已阅读并同意 <a href="/useragreement" target='_blank'>用户协议</a></Checkbox>

                    <Button type="primary" htmlType="submit" className="login-form-button" loading={loading} disabled={!data.botToken || !useragreement}>登录</Button>

                    {/* 
                    <Divider plain>
                        OR
                    </Divider>

                    <ConfigProvider
                        theme={{
                            token: {
                                // Seed Token, affects wide range
                                colorPrimary: '#00b96b',
                                borderRadius: 2,
                                // Derived token, affects narrow range
                                colorBgContainer: '#f6ffed',
                            },
                        }}
                    >
                        <Button type="primary" defaultBg='#07C160' onClick={() => { WXLogin() }} className="login-form-button" loading={loading} >(旧) 使用微信快速登录/注册</Button>
                    </ConfigProvider> */}



                    <a href="/register" className='login-form-register'>注册账户</a>
                    <a className="login-form-forgot" href="/forget_password">忘记密码?</a>
                    {/* <div>其他登录方式 <Button type="primary" onClick={QQ} shape="circle" icon={<QqOutlined />} size='small' /> </div> */}
                </Form.Item>
            </Form>
        </div>
    )
}





export default Login;